import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Responsive container component with max-width constraints
 *
 * @param {Object} props
 * @param {'sm'|'md'|'lg'|'xl'|'full'} props.size - Container max width
 * @param {boolean} props.noPadding - Remove horizontal padding
 * @param {ReactNode} props.children - Container content
 * @param {string} props.className - Additional CSS classes
 */
export const Container = ({
  size = 'lg',
  noPadding = false,
  children,
  className,
  ...props
}) => {
  const sizes = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-[1400px]',
    full: 'max-w-full',
  };

  return (
    <div
      className={cn(
        'mx-auto',
        !noPadding && 'px-4 sm:px-6 lg:px-8',
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
